<script>
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

import NoticeManageTableForm from './components';

formCreate.component('NoticeManageTableForm', NoticeManageTableForm);

export default {
  extends: Form,
  data() {
    return {
      rule: [],
    };
  },
  components: {
    formCreate: formCreate.$form(),
  },
  async mounted() {
    this.rule = await this.getFormRule('main_form');
    this.rule.map((v) => {
      const rowData = v;
      if (rowData.field === 'fileList') {
        rowData.props.showFileList = true;
        rowData.props.uploadType = 'file';
        rowData.props.listType = 'text';
        rowData.props.fileMsg = '只能上传pdf/word/excel/ppt/png/jpg文件';
        rowData.props.accept = '.pdf,.doc,.docx,.xlsx,.xls,.ppt,.pptx,.png,.jpg';
        if (this.formConfig.code === 'view') {
          rowData.props.disabled = true;
        }
      } else if (rowData.field === 'endTime' || rowData.field === 'beginTime') {
        rowData.props = {
          ...rowData.props,
          type: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          relation: {
            beginField: 'beginTime',
            endField: 'endTime',
          },
        };
      } else if (rowData.field === 'list') {
        rowData.props = {
          functionCode: '',
          selection: [],
          idKey: 'id',
          notView: this.formConfig.code !== 'view',
        };
        rowData.value = {
          orgList: [],
        };
      } else if (rowData.field === 'content') {
        rowData.props = {
          ...rowData.props,
          notView: this.formConfig.code === 'view',
        };
      } else if (rowData.field === 'noticeType') {
        rowData.on = {
          ...rowData.on,
          change: (val) => {
            if (val === 'notice') {
              this.hiddenFields(true, [
                'redirectPageFlag',
                'redirectPageUrl',
                'popupTime',
              ]);
            } else if (val === 'popup') {
              this.hiddenFields(false, [
                'redirectPageFlag',
                'redirectPageUrl',
                'popupTime',
              ]);
            }
          },
        };
      } else if (rowData.field === 'redirectPageFlag') {
        rowData.on = {
          ...rowData.on,
          change: (val) => {
            if (val === 'Y') {
              this.hiddenFields(false, ['redirectPageUrl']);
              this.getRule('redirectPageUrl').validate[0].required = true;
            } else if (val === 'N') {
              this.hiddenFields(true, ['redirectPageUrl']);
              this.getRule('redirectPageUrl').validate[0].required = false;
            }
          },
        };
      } else if (rowData.field === 'type') {
        rowData.on = {
          ...rowData.on,
          change: (val) => {
            const list = this.getRule('list');
            list.props = {
              ...list.props,
              type: val,
            };
          },
        };
      }
      return rowData;
    });
    this.reload(this.rule);
    if (this.formConfig.id) {
      this.getData();
    }
  },
  methods: {
    // 获取表单数据
    getData() {
      request
        .get('/cps/v1/fxhNotice/findById/', {
          id: this.formConfig.id,
        })
        .then((res) => {
          const data = {
            ...res.result,
            list: {
              orgList: res.result.orgList,
              terminalList: res.result.terminalList,
            },
          };
          const list = this.getRule('list');
          list.props.type = res.result.type;
          if (res.result.redirectPageFlag === 'N') {
            this.hiddenFields(true, ['redirectPageUrl']);
            this.getRule('redirectPageUrl').validate[0].required = false;
          }
          this.setValue(data);
        });
    },
    // 提交
    async submit() {
      const params = {
        ...this.getFormData(),
        orgList: this.getFormData().list.orgList.map((v) => {
          const rowData = v;
          rowData.customerName = '';
          rowData.customerCode = '';
          rowData.containFlag = 1;
          delete rowData.id;
          return rowData;
        }),
        terminalList: this.getFormData().list.terminalList.map((v) => {
          const rowData = v;
          delete rowData.id;
          return rowData;
        }),
      };
      delete params.list;

      let path = '/cps/v1/fxhNotice/save';
      if (this.formConfig.id) {
        path = '/cps/v1/fxhNotice/update';
        params.id = this.formConfig.id;
      }
      request.post(path, params).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.$emit('onClose');
          this.$emit('onGetList');
        }
      });
      return true;
    },
    // // 编辑赋值
    // initEditValue() {
    //   const submitType = this.formConfig.type;
    //   if (submitType === 'add') {
    //     this.resetFields();
    //   } else if (this.formConfig.row) {
    //     request
    //       .post('/mdm/mdmfunctionsub/query', { functionCode: this.formConfig.row })
    //       .then((res) => {
    //         this.setValue(res.result);
    //       });
    //   }
    // },
  },
};
</script>
